import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { errorCss } from '../../ui/Form/baseStyles/index.styles';

export const screenContainer = css({
  position: 'relative',
  paddingBottom: 110,
});

export const itemsContainerCss = {
  '.mid_sec': {
    display: 'flex',
    '.leftside': {
      width: '68.333%',
      marginLeft: '8%',

      [MediaQueries.lg]: {
        marginLeft: '0%',
      },

      [MediaQueries.md]: {
        width: '100%',
        marginLeft: '8%',
      },
      [MediaQueries.sm]: {
        width: '100%',
        marginLeft: '0',
      },

      '.left_mid_sec': {
        position: 'absolute',
        maxWidth: '500px',
        width: '100%',
      },

      '.form_sec': {
        position: 'relative',
        transition: 'all 0.5s',
        minHeight: '472px',
        padding: '32px 32px 32px 0px',
        background: '#fff',
        display: 'flex',
        marginTop: '32px',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '545px',

        '&[data-error="true"]': {
          border: `1px solid #000`,
        },
        [MediaQueries.md]: {
          position: 'relative',
          padding: '0px 0px 32px 0px',
          marginTop: '0px',
        },
        [MediaQueries.sm]: {
          position: 'relative',
          padding: '0px 0px 32px 0px',
          marginTop: '0px',
        },

        '.thankyou_sec': {
          h2: {
            fontSize: '69px',
            lineHeight: '64px',
            letterSpacing: '-0.30000001192092896px',
            textAlign: 'left',
            marginBottom: '48px',
            [MediaQueries.sm]: {
              fontSize: '48px',
              lineHeight: '56px',
            },
          },

          p: {
            fontSize: '22px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '-0.004em',
            textAlign: 'left',
            marginBottom: '24px',
          },

          '.location-name': {
            fontSize: '22px',
            lineHeight: '32px',
            letterSpacing: '-0.004em',
            textAlign: 'left',
            fontWeight: 500,
            marginBottom: '16px',
          },

          '.schedule-on': {
            display: 'flex',
            alignItems: 'center',
          },

          '.date,.time': {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',

            img: {
              marginBottom: '16px',
            },
          },

          '.rdtOpen': {
            position: 'absolute',
            top: '15px',
            width: '100%',
            maxWidth: '365px',
          },

          '.hrline': {
            borderRight: '#D9DBDD solid 1px',
            height: '80px',
            marginLeft: '16px',
            marginRight: '16px',
          },

          '.close_btn': {
            button: {
              minWidth: '186px',
              height: '56px',
              fontSize: '14px',
              marginTop: '30px',
              lineHeight: '18px',
              letterSpacing: '0.875px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'transparent',
              border: '#D9DBDD solid 1px',
              cursor: 'pointer',
            },

            'button:hover': {
              background: 'red',
              border: 'red solid 1px',
              color: '#fff',
            },
          },
        },

        '.dateinputfield': {
          marginBottom: '16px',
          div: {
            height: '56px',
            paddingTop: '12px',
            paddingBottom: '12px',
          },
        },

        '.timepicker': {
          width: '100%',

          div: {
            textAlign: 'left',
            paddingLeft: '15px',
            width: '100%',
          },
        },

        h2: {
          fontSize: '18PX',
          lineHeight: '32px',
          color: '#747475',
          fontWeight: '500',
          height: '64px',
          display: 'flex',
          alignItems: 'center',

          span: {
            marginLeft: '32px',
            maxWidth: '280px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '18px',
            color: '#747475',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '32px',
            letterSpacing: '0px',
            textAlign: 'left',
          },
        },

        // input: {
        //   background: '#ffffff',
        //   padding: '25px 16px 9px',
        //   border: '1px solid #d9dbdd',
        //   height: '56px',
        //   paddingTop: '17px',
        //   marginBottom: '16px',
        //   width: '100%',
        // },
      },

      '.next_btn': {
        position: 'relative',
        bottom: '0px',

        [MediaQueries.md]: {
          position: 'relative',
        },
        [MediaQueries.sm]: {
          position: 'relative',
        },

        button: {
          background: '#E52500',
          minWidth: '192px',
          border: '0',
          color: '#fff',
          fontSize: '14px',
          borderRadius: '8px',
          textTransform: 'uppercase',
          lineHeight: '18px',
          letterSpacing: '0.88px',
          fontWeight: '500',
          textAlign: 'center',
          cursor: 'pointer',
          padding: '19px',
        },

        'button:hover': {
          background: '#d42705',
          outlineColor: '#d42705',
        },
      },
    },

    '.rightside': {
      width: '100%',
      minHeight: '500px',
      display: 'flex',
      [MediaQueries.md]: {
        display: 'none',
      },
      [MediaQueries.lg]: {
        maxWidth: 'none',
        img: {
          width: '100%',
          objectFit: 'cover',
        },
      },
      [MediaQueries.sm]: {
        display: 'none',
      },

      img: {
        [MediaQueries.xl]: {
          width: '900px',
          objectFit: 'cover',
        },
      },
    },
  },
};

export const tabFormArea = css({
  borderLeft: '#EFEEE9 solid 4px',
  transition: 'all 0.5s linear',
  paddingLeft: '32px',
  marginBottom: '16px',
  paddingBottom: '16px',

  h2: {
    color: '#9c9c9c',
  },
  'h2.is-clickable': {
    color: 'black',
    cursor: 'pointer',
  },
});

export const isActive = css({
  borderLeft: '#008385 solid 4px',
  paddingBottom: '16px',
  h2: {
    color: '#393939 !important',
  },
});

// ----------

export const dateError = css(errorCss, {
  marginTop: 20,
});

export const header = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  paddingBottom: 30,
  [MediaQueries.mdAndUp]: {
    borderBottomWidth: 0,
    paddingBottom: 0,
    marginBottom: 50,
  },
});

export const backButton = css({
  minHeight: 48,
  minWidth: 48,
  border: 0,
  background: colorsPalette.transparent,
  marginTop: 15,
  paddingLeft: 5,
  textAlign: 'left',
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: -70,
  },
  [MediaQueries.lgAndUp]: {
    top: -82,
  },
});

export const backButtonIcon = css({
  fontSize: 22,
  [MediaQueries.mdAndUp]: {
    marginRight: 18,
  },
});

export const backButtonLabel = css(typography.effra16, {
  color: colorsPalette.black,
});

export const headline = css(typography.effra58Modal, {
  color: colorsPalette.grey,
  margin: '60px 0 22px',
  position: 'relative',
  [MediaQueries.mdAndUp]: {
    marginTop: 128,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 170,
  },
});

export const subtitleContainer = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
  },
});

export const phoneContainer = css({
  marginTop: 40,
  [MediaQueries.mdAndUp]: {
    marginTop: 10,
  },
  '.phone-container': {
    display: 'flex',
  },
  '.phone-label': {
    flex: 1,
    [MediaQueries.mdAndUp]: {
      flex: 'none',
    },
  },
  '.phone-number': {
    borderBottom: `1px solid ${colorsPalette.grey20}`,
    paddingBottom: 6,
    fontSize: 18,
    [MediaQueries.mdAndUp]: {
      border: 0,
      paddingBottom: 0,
      fontSize: 16,
    },
  },
});

export const location = css(typography.effra22, {
  fontWeight: fontWeights.medium,
  lineHeight: 1.45,
  margin: '22px 0 10px',
});

export const address = css(typography.effra18, {
  color: colorsPalette.grey80,
  lineHeight: 1.6,
});

export const dateInstruction = css(typography.effra16, {
  color: colorsPalette.grey80,
});

export const submitButtonContainer = css({
  backgroundColor: colorsPalette.white,
  boxShadow: `0 0 15px 6px ${colorsPalette.white}`,
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  padding: '24px',
  zIndex: 3,
  [MediaQueries.mdAndUp]: {
    position: 'relative',
    boxShadow: 'none',
    padding: 0,
    maxWidth: 190,
    marginTop: 40,
  },
});

export const timePicker = css({
  maxWidth: 590,
});

export const infoFormContainer = css({
  marginTop: 40,
  '.enquiry-input': {
    marginBottom: 32,
  },
});

export const dropdownContainer = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    '.enquiry-input': {
      flex: 1,
      '&:first-child': {
        marginRight: 20,
      },
    },
  },
});

export const dateSummaryContainer = css({
  display: 'flex',
  margin: '25px 0 50px',
  [MediaQueries.mdAndUp]: {
    textAlign: 'center',
  },
});

export const dateSummaryLeftItem = css({
  borderRight: `1px solid ${colorsPalette.grey20}`,
  paddingRight: 35,
});

export const dateSummaryRightItem = css({
  paddingLeft: 35,
});

export const dateSummaryLabel = css(typography.effra16, {
  wordBreak: 'break-all',
  display: 'block',
  color: colorsPalette.grey60,
});

export const dateSummaryValue = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
});
